<template>
    <li class="nav-item">
        <router-link to="/cart" class="nav-link">
            <font-awesome-icon icon="cart-shopping" class="text-secondary" />
            <span v-if="cart_total > 0" class="cart-count">
                {{ cart_total }}
            </span>
        </router-link>
    </li>
    <li class="nav-item">
        <router-link to="/notification" class="nav-link">
            <font-awesome-icon icon="bell" class="text-secondary" />
            <span v-if="notification_total > 0" class="notification-count">
                {{ notification_total }}
            </span>
        </router-link>
    </li>
</template>
  
<script>
import CartService from "@/services/cart.service";
import NotificationService from "@/services/notification.service";

export default {
    name: "NavbarNotification",
    components: {},
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    data() {
        return {
            cart_total: 0,
            notification_total: 0,
            loadingData: false,
        };
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        loadData() {
            this.loadingData = true;
            if (this.currentUser) {
                Promise.all([
                    CartService.getNotificationCountByUserId(this.currentUser.id),
                    NotificationService.getNotificationCountByUserId(this.currentUser.id),
                ])
                    .then((responses) => {
                        this.notification_total = responses[1].data.data;
                        setTimeout(() => {
                            this.cart_total = responses[0].data.data;
                        }, 10);
                    })
                    .catch(() => {
                        this.cart_total = 0;
                        this.notification_total = 0;
                    })
                    .finally(() => {
                        this.loadingData = false;
                    });
            } else {
                this.cart_total = 0;
                this.notification_total = 0;
                this.loadingData = false;
            }
        },
    },
    watch: {
        loading() {
            if (!this.loadingData) {
                this.loadData();
            }
        },
    },
};
</script>

<style scoped>
.cart-count {
    background-color: red;
    color: white;
    font-size: 9px;
    border-radius: 50%;
    padding: 0;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    position: absolute;
    top: 9px;
    right: 42px;
}

.notification-count {
    background-color: red;
    color: white;
    font-size: 9px;
    border-radius: 50%;
    padding: 0;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    position: absolute;
    top: 9px;
    right: 14px;
}
</style>